// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as NLOrderTimesVm from "./vm-mapper/NLOrderTimesVm.bs.js";
import * as RecordsWrapper from "./RecordsWrapper.bs.js";
import * as Accordion$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/Accordion.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";

function getViewLabel(times) {
  return {
          hd: {
            label: "Created Time",
            value: {
              TAG: /* Text */0,
              _0: times.created_time
            }
          },
          tl: {
            hd: {
              label: "Pickup Time",
              value: {
                TAG: /* Text */0,
                _0: times.pickup_time
              }
            },
            tl: {
              hd: {
                label: "Scheduled Pickup Time",
                value: {
                  TAG: /* Text */0,
                  _0: times.scheduled_pickup_time
                }
              },
              tl: {
                hd: {
                  label: "Trip Started Time",
                  value: {
                    TAG: /* Text */0,
                    _0: times.start_time
                  }
                },
                tl: {
                  hd: {
                    label: "Accepted Time",
                    value: {
                      TAG: /* Text */0,
                      _0: times.accepted_time
                    }
                  },
                  tl: {
                    hd: {
                      label: "Trip Ended Time",
                      value: {
                        TAG: /* Text */0,
                        _0: times.trip_end_time
                      }
                    },
                    tl: {
                      hd: {
                        label: "Trip Cancelled Time",
                        value: {
                          TAG: /* Text */0,
                          _0: times.cancelled_time
                        }
                      },
                      tl: {
                        hd: {
                          label: "Job Ended Time",
                          value: {
                            TAG: /* Text */0,
                            _0: times.job_end_time
                          }
                        },
                        tl: {
                          hd: {
                            label: "Check Wait Time",
                            value: {
                              TAG: /* Text */0,
                              _0: times.check_wait_time
                            }
                          },
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
}

function NLOrderTimes(Props) {
  var order = Props.order;
  var order_fare = Props.order_fare;
  var times = NLOrderTimesVm.getVm(order, order_fare);
  return React.createElement(Accordion$Catalyst.make, {
              panels: {
                hd: AccordionTypes$Catalyst.make_props({
                      TAG: /* Text */0,
                      _0: "Order Times"
                    }, undefined, undefined, React.createElement(RecordsWrapper.make, {
                          children: CardRowViewMapper$Catalyst.CardRecordView.make("record", getViewLabel(times))
                        }), undefined),
                tl: /* [] */0
              },
              className: "c-nlo-accordion-cmp"
            });
}

var make = NLOrderTimes;

export {
  getViewLabel ,
  make ,
  
}
/* react Not a pure module */
